import subFields from '../../block/commitment/inputs';
import { createInputs } from '../../utils';

export default createInputs([
  { name: 'image', type: 'file', required: true },
  { name: 'title', type: 'string', required: true },
  { name: 'items', type: 'list', required: true, subFields },
]);
